import React, { Component } from 'react'
import Banner from './components/Banner/Banner'
import Services from "./components/services/Services";
import Descrip from './components/services/services.discrip'
import Joinus from './components/joinus/Joinus'
import Moto from './components/moto/moto'
import Projects from './components/projects/projects'
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer'
import Team from './components/team/Team'
import { auth } from './firebase/firebase-utils'


class App extends Component {
  constructor() {
    super()

    this.state = {
      User: null
    }
  }
  unSubscribeFromAuth = null;
  componentDidMount = () => {
    this.unSubscribeFromAuth = auth.onAuthStateChanged(user => {
      this.setState({ User: user })
    })
  }
  // componentWillUnmount = () => {
  //   this.unSubscribeFromAuth = null;
  // }
  render() {
    return (
      <div style={{ background: '#001a21', overflowX: 'hidden' }}>
        <Banner user={this.state.User} />
        <Services user={this.state.User} />
        <Descrip />
        <Projects />
        <Moto />
        <Team />
        <Contact />
        <Joinus user={this.state.User} />
        <Footer user={this.state.User} />
      </div>
    );
  }

}

export default App;
